import { Outlet } from 'react-router';

export const Layout = ({ availableEmbedHeight }: { availableEmbedHeight?: number }) => (
  <main
    className="slds-template_default"
    style={{
      background: 'var(--slds-g-color-surface-2)',
      display: 'flex',
      flexDirection: 'column',
      minHeight: availableEmbedHeight ?? '100dvh',
    }}
  >
    <Outlet />
  </main>
);
